import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        /* 問題データ */
        json: null,
        /* 回答データ */
        answerData: null,
    },
    getters: {

    }
});